var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.845,
    height: 14.845,
    viewBox: "0 0 14.845 14.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "external-link",
    transform: "translate(-2.35 -2.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25313",
    "data-name": "Path 25313",
    d: "M14.063,11.163v4.425a1.475,1.475,0,0,1-1.475,1.475H4.475A1.475,1.475,0,0,1,3,15.588V7.475A1.475,1.475,0,0,1,4.475,6H8.9",
    transform: "translate(0 -0.787)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25314",
    "data-name": "Path 25314",
    d: "M15,3h4.425V7.425",
    transform: "translate(-3.149)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3265",
    "data-name": "Line 3265",
    y1: 7.936,
    x2: 7.936,
    transform: "translate(8.34 3)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.ce544f167b73c19446701911bc7a1f2c.svg";
export { ForwardRef as ReactComponent };